import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  LOADING_USER
} from "../types";
import axios from "axios";

export const loginUser = (userCredentials, history) => dispatch => {
  dispatch({ type: LOADING_UI });
  axios
    .post("/login", userCredentials)
    .then(res => {
      setAuthorizationHeader(res.data.token);
      dispatch(getAuthenticatedUser());
      dispatch({ type: CLEAR_ERRORS });
      history.push("/");
    })
    .catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
};

export const signupUser = (newUserDetails, history) => dispatch => {
  dispatch({ type: LOADING_UI });
  axios
    .post("/signup", newUserDetails)
    .then(res => {
      setAuthorizationHeader(res.data.token);
      dispatch(getAuthenticatedUser());
      dispatch({ type: CLEAR_ERRORS });
      history.push("/");
    })
    .catch(err => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
};

export const logoutUser = () => dispatch => {
  localStorage.removeItem("firebaseIdToken");
  delete axios.defaults.headers.common["Authorization"];
  dispatch({ type: SET_UNAUTHENTICATED });
  window.location.href = "/";
};

const setAuthorizationHeader = token => {
  const firebaseIdToken = `Bearer ${token}`;
  localStorage.setItem("firebaseIdToken", firebaseIdToken);
  axios.defaults.headers.common["Authorization"] = firebaseIdToken;
};

export const getAuthenticatedUser = () => dispatch => {
  dispatch({ type: LOADING_USER });

  axios
    .get("/user")
    .then(res => {
      dispatch({
        type: SET_USER,
        payload: res.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};
